import { ChainFullIds } from "@umami/chains";
import { type UnifiedBalanceWithPrices } from "@umami/state";

export const DEFAULT_RAMP_TOKENS: UnifiedBalanceWithPrices[] = [
  {
    chainId: ChainFullIds.TEZOS,
    symbol: "XTZ",
    balance: "0",
    usdPrice: 0,
    totalUsdPrice: 0,
  },
  {
    chainId: ChainFullIds.ETHERLINK,
    symbol: "XTZ",
    balance: "0",
    usdPrice: 0,
    totalUsdPrice: 0,
  },
  {
    chainId: ChainFullIds.ETHERLINK,
    symbol: "USDC",
    balance: "0",
    usdPrice: 0,
    totalUsdPrice: 0,
  },
  {
    chainId: ChainFullIds.ETHEREUM,
    symbol: "USDC",
    balance: "0",
    usdPrice: 0,
    totalUsdPrice: 0,
  },
  {
    chainId: ChainFullIds.ETHEREUM,
    symbol: "USDT",
    balance: "0",
    usdPrice: 0,
    totalUsdPrice: 0,
  },
  {
    chainId: ChainFullIds.ETHEREUM,
    symbol: "ETH",
    balance: "0",
    usdPrice: 0,
    totalUsdPrice: 0,
  },
  {
    chainId: ChainFullIds.ETHEREUM,
    symbol: "WETH",
    balance: "0",
    usdPrice: 0,
    totalUsdPrice: 0,
  },
];
